import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "#2159f6" }, [
      _createElementVNode("path", {
        "data-name": "Vector",
        d: "m14.485 12.878-2.707-3.607H7.771a.769.769 0 0 0-.543 1.314l3.7 3.7a1.522 1.522 0 0 0 2.15 0Z",
        opacity: ".32"
      }),
      _createElementVNode("path", {
        "data-name": "Vector",
        d: "M16.227 9.271h-4.45l2.707 3.607 2.293-2.293a.773.773 0 0 0-.55-1.314Z"
      })
    ], -1)
  ]))]))
}
export default { render: render }